import React from 'react';
import FAQItem from 'components/presentational/FAQItem';
import PropTypes from 'prop-types';
import './faq-form.scss';

const FAQForm = (props) => (
    <form className="faq-form" onSubmit={props.handleSubmit}>
        {props.formItems.map((item, id) => (
            <FAQItem 
                {...item} 
                id={id} 
                key={id} 
                handleCheckboxChange={props.handleCheckboxChange}
                handleRadioBtnChange={props.handleRadioBtnChange}
            /> 
        ))}
        
        <button className="faq-form__submit"
            disabled={props.formIsValid ? '' : 'disabled'}>
            SUBMIT
        </button>
    </form>
);

FAQForm.propTypes = {
    formItems: PropTypes.array.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleCheckboxChange: PropTypes.func.isRequired,
    handleRadioBtnChange: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool,
}

export default FAQForm
